import React from 'react'
import './header.css'
import { Link } from "react-router-dom";
import Nav from './Nav';


const Header = () => {
  return ( 
    <div className='header home'>
      <Nav/>
        
        <div className="heading"> 
                <h1>Complete and Specialized<br />
                    Logistics Solutions for<br />
                    Supply Chain. 
                </h1>

                <p>We provide complete and specialized logistics solutions for <br />
                the improvement of your supply chain. Get to know the status <br />
                of your shipment.</p>
        </div>

        <button className='button'>
        <a href="https://tracking.splendidfreight.com/tracking.php"  style={{ color: 'black' }}>TRACK SHIPMENT</a>
        </button>
    </div>

   
  )
}

export default Header
